import defaultLayout from '../../../layouts/default'
import store from '../../../store'

export default {
  path: 'ai',
  component: defaultLayout,
  children: [
    {
      path: 'view',
      component: () => import('./view/index.vue'),
      meta: {
        activeMenu: 'card',
        auth: true,
        keepAlive: true,
        customHead: true
      },
      beforeEnter(to, from, next) {
        const privilege_info = store.state.user?.user_info?.privilege_info
        if (!privilege_info) {
          next({ path: '/user/login', replace: true })
          return
        }
        if (privilege_info.show_company_cardholder === 'y') {
          next()
        } else if (privilege_info.show_manage == 'y') {
          next({ path: '/admin/accountinfo' })
        } else {
          next({ path: '/noPermission' })
        }
      }
    }
  ]
}
